import api from "@/lib/api";

export interface PutPaymentInformationRequest {
  transactionId: string;
}

export interface PutPaymentInformationResponse {
  contractNumber: string;
  status: string;
  message_type: string;
  errorCode: string;
}

export default {
  // 通常契約登録 API
  putPaymentInformation(data: any) {
    return api<PutPaymentInformationRequest, PutPaymentInformationResponse>({
      endpoint: "payment-informations/web-api/edit",
      method: "PUT",
      body: data
    });
  }
};
